(()=>{
  if(window.loaIntentMeasurement)return;
  window.loaIntentMeasurement=true;
  const pageKeys=new Set(['home','academy','books','story','consulting','contact']);
  const products=new Set(['lawofambition-ebook','lawofambition-quotes-ebook','entrepreneur101-eworkbook','entrepreneur-starter-pack']);
  const shopHosts=new Set(['www.lawofambition.com','lawofambition.com',location.hostname]);
  function pageKey(){const key=document.body?.dataset.page;return pageKeys.has(key)?key:'other';}
  function placement(link){
    if(link.closest('#ambition-dialog'))return 'popup';
    if(link.closest('.site-header,.site-menu'))return 'navigation';
    if(link.closest('.site-footer'))return 'footer';
    if(link.closest('.book-product,.starter-feature'))return 'product_card';
    if(link.closest('.closing-section'))return 'closing';
    if(link.closest('.page-intro'))return 'page_intro';
    return 'page_content';
  }
  function classify(link){
    let url;try{url=new URL(link.getAttribute('href'),location.href);}catch(error){return null;}
    if(!['https:','http:'].includes(url.protocol))return null;
    const path=url.pathname.replace(/\/+$/,'')||'/';
    if(shopHosts.has(url.hostname)){
      if(path==='/pages/free-training')return {event:'academy_signup_click',destination:'free_training'};
      const product=path.match(/^\/products\/([^/]+)$/)?.[1];
      if(products.has(product))return {event:'book_purchase_click',destination:'product_details',item_id:product};
      if(pageKey()==='consulting'&&['/contact/','/contact','/pages/contact','/pages/contact-team'].includes(path))return {event:'consulting_inquiry_click',destination:'contact_form'};
    }
    if(pageKey()==='consulting'&&url.hostname==='ig.me'&&path==='/m/lawofambition')return {event:'consulting_inquiry_click',destination:'instagram_message'};
    return null;
  }
  function allowed(purpose='analyticsProcessingAllowed'){
    try{return window.Shopify?.customerPrivacy?.[purpose]?.()===true;}catch(error){return false;}
  }
  function measure(event){
    if(!event.isTrusted||event.defaultPrevented||(event.type==='click'&&event.button!==0)||(event.type==='auxclick'&&event.button!==1))return;
    const link=event.target?.closest?.('a[href]');if(!link)return;
    const intent=classify(link);if(!intent||!allowed())return;
    const {event:name,...details}=intent;
    const payload={...details,page_key:pageKey(),placement:placement(link),intent_only:true};
    const analytics=window.Shopify?.analytics;
    if(typeof analytics?.publish==='function'){
      try{const result=analytics.publish('law_of_ambition:'+name,payload);result?.catch?.(()=>{});}catch(error){}
    }
    if(typeof window.TriplePixel==='function'&&window.TriplePixelData?.TripleName==='law-of-ambition-loa.myshopify.com'&&allowed('marketingAllowed')&&allowed('saleOfDataAllowed')){
      try{window.TriplePixel('custom','loa_'+name,payload);}catch(error){}
    }
  }
  document.addEventListener('click',measure);
  document.addEventListener('auxclick',measure);
  if(!window.Shopify?.customerPrivacy&&typeof window.Shopify?.loadFeatures==='function'){
    try{window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>{});}catch(error){}
  }
})();
